'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HAS_SERVICE_WORKER_SUPPORT = exports.HAS_SERVICE_WORKER_SUPPORT = Boolean(window && window.navigator && window.navigator.serviceWorker);

var HAS_SERVICE_WORKER_POST_MESSAGE_SUPPORT = exports.HAS_SERVICE_WORKER_POST_MESSAGE_SUPPORT = Boolean(window && window.navigator && window.navigator.serviceWorker && window.navigator.serviceWorker.addEventListener);

var HAS_LOCAL_STORAGE_SUPPORT = exports.HAS_LOCAL_STORAGE_SUPPORT = window.hasOwnProperty('localStorage');